'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class CustomSwitch extends _react.PureComponent {
  state = {
    id: String(++app.form_index)
  };
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: [true, 'true'].includes(props['default-value']),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    props.onChange({
      e: e,
      value: e.target.checked,
      name: props.name
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let class_name = props.className;
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-switch';
    const checked = [true, 'true'].includes(props.value);
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, props['top-label'] ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label top u-no-select",
      htmlFor: state.id
    }, props['top-label']) : undefined, /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, props['left-label'] ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label left u-no-select",
      htmlFor: props.label ? checked ? state.id : undefined : state.id
    }, props['left-label']) : undefined, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      checked: checked,
      onChange: component.handleChange,
      name: props.name,
      color: "primary",
      className: props['switch-class'],
      style: {
        height: 'auto'
      },
      id: state.id,
      disabled: props['read-only'] === true
    }), props.label ? /*#__PURE__*/_react.default.createElement("label", {
      className: "switch-label right u-no-select",
      htmlFor: props['left-label'] ? checked ? undefined : state.id : state.id
    }, props.label) : undefined));
    return output;
  }
}
exports.default = CustomSwitch;
CustomSwitch.propTypes = {
  'default-value': _propTypes.default.bool,
  'full-width': _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  'switch-class': _propTypes.default.string,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  status: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func.isRequired
};
CustomSwitch.defaultProps = {
  'full-width': true,
  'default-value': false,
  className: ''
};
